import React, { memo, RefObject, useCallback, useEffect } from "react";
import styles from "./Caption.module.css";
import { ParentComponentProps } from "../../../../../common/ParentComponentProps";
import { Text14 } from "../../../../../common/components/typography/Typography";
import clsx from "clsx";
import { stringifyVideoTimeWithColons } from "../../../../../common/video/util/videoTimeStrings";
import EditCaption from "../../../../../pages/vod/Common/EditCaption";
import { isAdmin, isEditor } from "../../../../../utils/LogicUtils";
import { useSelector } from "react-redux";
import { AppState } from "../../../../../root/RootReducer";
import PuiTypography from "../../../../../components/elements/PuiTypography";
import { useInitFlag } from "../../../../../components/function/useInitFlag";

interface CaptionProps extends ParentComponentProps {
    isCurrentCaption: boolean;
    videoRef: RefObject<HTMLVideoElement>;
    startTimeMillis: number;
    id: number;
    text: string;
    captionElement: null | HTMLElement;
    setEditModalOpen: (target: boolean) => void;
}

function Caption({children, isCurrentCaption, startTimeMillis, videoRef, id, text, captionElement, setEditModalOpen}: CaptionProps) {
    // ユーザーロール取得用
    const {user} = useSelector((state: AppState) => ({
        user: state.user.user
    }));

    const classes = clsx(styles.caption, {
        [styles.currentCaption]: isCurrentCaption
    });

    // Caption編集中フラグ
    const [isCaptionEditing, setIsCaptionEditing] = useInitFlag();

    const handleClick = useCallback(() => {
        if (videoRef.current && !isCaptionEditing) {
            videoRef.current.currentTime = startTimeMillis / 1000;
        }
    }, [startTimeMillis, videoRef, isCaptionEditing]);

    // スクロール位置更新
    useEffect(() => {
        if(isCurrentCaption === true && captionElement !== null){
            if(captionElement){
                const offsetTop = captionElement.offsetTop;
                const currentCaption = document.getElementById(String(id));
                if(currentCaption){
                    const top = currentCaption.offsetTop;
                    captionElement.scrollTop = top - offsetTop;
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCurrentCaption]);


    return (
        <div className={classes} onClick={handleClick} id={String(id)}>
            <div className={styles.timestamp}>
                <PuiTypography size={14} color="gray-61">
                    {stringifyVideoTimeWithColons(startTimeMillis, true)}
                </PuiTypography>
                {(isAdmin(user?.roles) || isEditor(user?.roles)) && (
                    <div style={{ marginLeft: "6px" }}>
                        <EditCaption
                            captionId={id}
                            beforeEditText={text}
                            setEditModalOpen={setEditModalOpen}
                            setIsCaptionEditing={setIsCaptionEditing}
                        />
                    </div>
                )}
            </div>

            <div className={styles.body}>
                <Text14>{children}</Text14>
            </div>
        </div>
    );
}

export default memo(Caption);
